import type { WeatherReport } from '../../shared/contract'

export interface EdgeBoot { key: string; promise: Promise<unknown> }
declare global { interface Window { __wfEdge?: EdgeBoot } }

/** Lossless SI representation of the cached DO report; never reconstruct missing fields
 * from the rounded public API. Edge provenance stays visible until browser refinement. */
export async function edgeReport(lat: number, lon: number): Promise<WeatherReport | null> {
  try {
    const boot = typeof window !== 'undefined' ? window.__wfEdge : undefined
    const key = `${lat.toFixed(3)},${lon.toFixed(3)}`
    let timer: ReturnType<typeof setTimeout> | undefined
    const timeout = new Promise<null>(resolve => { timer = setTimeout(() => resolve(null), 8000) })
    const request = (boot?.key === key ? boot.promise : fetch(
      `/v2/forecast?latitude=${lat.toFixed(2)}&longitude=${lon.toFixed(2)}&format=report`,
      { signal: AbortSignal.timeout(8000) },
    ).then((r) => r.ok ? r.json() : null))
    const raw = await Promise.race([request, timeout]).finally(() => clearTimeout(timer))
    const r = raw as WeatherReport | null
    if (!r || r.version !== 2 || !Array.isArray(r.sources) || !Array.isArray(r.hourly) || !r.hourly.length || !Array.isArray(r.daily) || !r.daily.length || !r.astronomy || !r.fusion) return null
    if (Math.abs(r.location.latitude - lat) > 0.011 || Math.abs(r.location.longitude - lon) > 0.011) return null
    return r
  } catch { return null }
}
